/* eslint-disable no-useless-escape */
export default (t) => {
    return [
        {
            title: '',
            className: 'details',
            licensingPlan: [
                t('Number of engines'),
                t('File size limit'),
                t('Throttling (requests/min) ¹'),
                t('Prevention API Limit (requests / day)'),
                t('Reputation API Limit (requests / day)'),
                t('Analysis API Limit (requests / day)'),
                t('Maximum number of files in archives'),
                t('Archive recursion level'),
                t('Number of IP-Domain reputation engines'),
                t('Data Sanitization (CDR)'),
                t('File Privacy'),
                t('Request Priority'),
                t('Secure SSL support'),
                t('Availability SLA'),
                t('Response Time ²'),
                t('Recovery Time Objective'),
                t('Support'),
                t('End to End Encryption ³'),
                t('Monthly rate limiting plans'),
                t('IP range restrictions'),
                t('Limit exceed permitted ⁴'),
                t('Mutual TLS'),
                t('Customer provided IDP'),
                t('Auditing / Alerting'),
                t('Custom domain'),
                t('Reporting')
            ]
        },
        {
            title: t('Personal'),
            className: 'free',
            licensingPlan: [
                'freeEngines',
                '140 MB',
                '10',
                '40',
                '4,000',
                '5',
                '50',
                '1',
                t('up to 30'),
                t('Active'),
                t('Files shared with AV vendors'),
                t('Standard priority'),
                t('Yes'),
                '-',
                '',
                '-',
                '-',
                '-',
                '-',
                '-',
                '-',
                '-',
                '-',
                '-',
                '-',
                t('Once Available')
            ]
        },
        {
            title: t('Commercial'),
            className: 'commercial',
            licensingPlan: [
                'commercialEngines',
                '256 MB',
                '100',
                t('Flexible daily'),
                t('Flexible daily'),
                t('Flexible daily'),
                '1,000',
                '5',
                t('up to 30'),
                t('Active'),
                t('Controlled by end user'),
                t('High priority'),
                t('Yes'),
                '99.5%',
                [
                    {
                        text: t('8 seconds for scanning and CDR (p50)')
                    },
                    {
                        text: t('500ms API calls (p50)')
                    }
                ],
                t('24 hours'),
                t('Up to, Platinum Support'),
                t('Once Available'),
                '-',
                '-',
                '-',
                '-',
                '-',
                '-',
                '-',
                t('Once Available')
            ]
        },
        {
            title: t('Enterprise '),
            className: 'enterprise',
            licensingPlan: [
                'enterpriseEngines',
                '1 GB',
                t('200 (further increase on demand)'),
                t('Flexible daily and monthly'),
                t('Flexible daily and monthly'),
                t('Flexible daily and monthly'),
                '100,000',
                '50',
                t('up to 30'),
                t('Active'),
                t('Controlled by organization policy'),
                t('Highest'),
                t('Yes'),
                '99.9%',
                [
                    {
                        text: t('8 seconds for scanning and CDR (p90)')
                    },
                    {
                        text: t('500ms API calls (p90)')
                    }
                ],
                t('2 hours'),
                t('Up to, Platinum Support'),
                t('Once Available'),
                t('Yes'),
                t('Yes'),
                '10%',
                t('Yes'),
                t('Yes'),
                t('Once Available'),
                t('Once Available'),
                t('Once Available')
            ]
        }
    ];
};

